import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Side ikke fundet" path="/404" description="Siden findes ikke." />
      <section className="min-h-[70vh] grid place-items-center px-5 py-32">
        <div className="text-center max-w-xl">
          <div className="font-display text-7xl sm:text-9xl font-bold text-[hsl(var(--accent))]">404</div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold mt-6">Siden findes ikke</h1>
          <p className="mt-4 text-white/60">
            Vi kunne ikke finde den side du leder efter. Den er måske flyttet eller findes ikke længere.
          </p>
          <Link
            to="/"
            className="btn-pop mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[hsl(var(--accent))] text-[hsl(var(--accent-ink))] font-semibold"
          >
            Tilbage til forsiden →
          </Link>
        </div>
      </section>
    </>
  );
}
